import React, { lazy } from 'react'
import Loadable from 'app/components/Loadable/Loadable'
import CartViewer from './orders/CartViewer'

const CustomerList = Loadable(lazy(() => import('./customers/CustomerList')))
const CustomerForm = Loadable(lazy(() => import('./customers/customer-form/CustomerForm')))
const CustomerViewer = Loadable(lazy(() => import('./customers/customer-viewer/CustomerViewer')))
const ClientForm = Loadable(lazy(() => import('./clients/client-form/ClientForm')))
const ClientList = Loadable(lazy(() => import('./clients/ClientList')))
const ClientDetails = Loadable(lazy(() => import('./clients/client-viewer/ClientViewer')))
const CustomerAwaitingPhoto = Loadable(lazy(() => import('./customers/CustomerAwaitingPhoto')))
const LoginAsClient = Loadable(lazy(() => import('../sessions/login/LoginAsClient')))
const BulkImport = Loadable(lazy(() => import('./clients/BulkImport/BulkImport')))
const NewStoreForm = Loadable(lazy(() => import('./stores/NewStoreForm')))
const StoreList = Loadable(lazy(() => import('./stores/StoreList')))
const OrdersList = Loadable(lazy(() => import('./orders/OrdersList')))
const SaOrdersList = Loadable(lazy(() => import('./orders/SaOrdersList')))
const OrderViewer = Loadable(lazy(() => import('./orders/OrderViewer')))
const JobsList = Loadable(lazy(() => import('./jobs/JobsList')))
const EmailLogs = Loadable(lazy(() => import('./email-logs/EmailLogs')))

const pagesRoutes = [
    {
        path: '/pages/new-client/:id',
        element: <ClientForm />,
    },
    {
        path: '/clients/bulk-import/:id',
        element: <BulkImport />,
    },
    {
        path: '/pages/view-client/:id',
        element: <ClientDetails />,
    },
    {
        path: '/pages/client-list',
        element: <ClientList />,
    },
    {
        path: '/pages/record-list',
        element: <CustomerList status="all" />,
    },
    {
        path: '/pages/await-photo',
        element: <CustomerAwaitingPhoto status="waiting" />,
    },
    {
        path: '/pages/new-record/:id',
        element: <CustomerForm />,
    },
    {
        path: '/pages/view-record/:id',
        element: <CustomerViewer />,
    },
    {
        path: '/pages/client-login/:id',
        element: <LoginAsClient />,
    },
    {
        path: '/pages/new-location/:id',
        element: <NewStoreForm />,
    },
    {
        path: '/pages/location-list',
        element: <StoreList />,
    },
    {
        path: '/pages/orders/',
        element: <OrdersList />,
    },
    {
        path: '/pages/sa-orders',
        element: <SaOrdersList />,
    },
    {
        path: '/pages/order/:id',
        element: <OrderViewer />,
    },
    {
        path: '/pages/jobs/new-job',
        element: <JobsList status="confirmed" />,
    },
    {
        path: '/pages/jobs/in-production',
        element: <JobsList status="inproduction" />,
    },
    {
        path: '/pages/jobs/dispatched-jobs',
        element: <JobsList status="dispatched" />,
    },
    {
        path: '/pages/orders/cart',
        element: <CartViewer />,
    },
    {
        path: '/settings/email-logs',
        element: <EmailLogs />,
    }
]

export default pagesRoutes
